import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	useUpdateTicketingProfileMutation,
	UpdateTicketingProfileInput,
} from './__generated__/useUpdateTicketingProfileMutation.graphql';

const mutation = graphql`
	mutation useUpdateTicketingProfileMutation($input: UpdateTicketingProfileInput!) {
		updateTicketingProfile(input: $input) {
			clientMutationId
			user {
				id
				emailSignature
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateTicketingProfileInput,
	onCompleted?: (r: useUpdateTicketingProfileMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useUpdateTicketingProfileMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useUpdateTicketingProfileMutation'};
